/* tslint:disable */
/* eslint-disable */
/**
 * MEP campaigns
 * API for retrieving campaign information.
 *
 * The version of the OpenAPI document: _
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Campaign,
    CampaignFromJSON,
    CampaignToJSON,
} from '../models';

/**
 * 
 */
export class CampaignsApi extends runtime.BaseAPI {

    /**
     * Returns campaign information for Mise en Place
     * Returns a list of campaigns available for the whitelabel
     */
    async campaignsGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Campaign>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/campaigns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignFromJSON));
    }

    /**
     * Returns campaign information for Mise en Place
     * Returns a list of campaigns available for the whitelabel
     */
    async campaignsGet(initOverrides?: RequestInit): Promise<Array<Campaign>> {
        const response = await this.campaignsGetRaw(initOverrides);
        return await response.value();
    }

}
